import { TextField } from "@mui/material"
import { IUser, IUserGroup, IUserLog, IUser_Group } from "bets.oddprovider.lib.common.ts/models"
import { CommonUtils } from "fwork-jsts-common/src"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled, TextPwdComponent } from "fwork.react.apptemplate"
import { FilterQuery } from "mongoose"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../apiClient/axios"
import { UsersApiClient } from "../../apiClient/users"
import { UsersLogsApiClient } from "../../apiClient/usersLogs"
import { DEFAULTGAP } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"
import { UserAddInfoTabsComponent } from "./userAddInfoTabs"

export const UserComponent = (props: {
  id?: number
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [data, setData] = useState<IUser>()
  const [confirmedPwd, setConfirmedPwd] = useState<string>()
  const [where, setWhere] = React.useState<FilterQuery<IUserLog> | undefined>()

  useEffect(() => {
    if (props.id)
      getData()
    else
      setData({} as IUser)
  }, [])

  const getData = async () => {
    try {
      const response = await new UsersApiClient(axios).get({
        where: {
          id: Number(props.id)
        },
        exclude: '_id',
        nested: 'groups{usergroup}',
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        setData(response.data.payload[0])
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
    }
  }

  const getLogs = async () => {
    try {
      const response = await new UsersLogsApiClient(axios).get({
        where,
        sort: { name: 1 }
      })

      if (response.success) {
        setData(prev => {
          return {
            ...prev,
            logs: response.data?.payload
          } as IUser
        })
      }

      if (!response.data?.payload?.length)
        enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })

    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
    }
  }

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (data?.pwd != confirmedPwd)
      return

    if (saving) return
    setSaving(true)
    try {
      if (data) {
        const response =
          data.id ? await new UsersApiClient(axios).put({ data }) : await new UsersApiClient(axios).post({ data })
        if (response.success) {
          if (response.data?.id)
            data.id = response.data?.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          disabled={data?.login == 'root'}
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label={"Nome"}
          onChange={(e) => setData({
            ...data,
            name: e.target.value
          } as IUser)}
        />
      </FormItemStyled>

      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          disabled={data?.login == 'root'}
          InputLabelProps={{ shrink: true }}
          value={data?.login || ''}
          label={"Login"}
          onChange={(e) => setData({
            ...data,
            login: e.target.value
          } as IUser)}
        />
      </FormItemStyled>
    </FormStyled>

    <FormStyled gap={DEFAULTGAP}>
      {data?.id ? <FormItemStyled gap={DEFAULTGAP}>
        <TextPwdComponent
          props={{
            autoComplete: 'new-password',
            label: 'Para alterar a senha entre com a senha anterior',
            value: data?.old_pwd,
            onChange: (e) => setData({
              ...data,
              old_pwd: e.target.value
            } as IUser),
          }}
        />
      </FormItemStyled> : <></>}

      {data?.old_pwd || !data?.id ? <FormItemStyled gap={DEFAULTGAP}>
        <TextPwdComponent props={{
          autoComplete: 'new-password',
          label: data?.id ? 'Insira a nova senha' : 'Senha',
          onChange: (e) => setData({
            ...data,
            pwd: e.target.value
          } as IUser),
        }}
        />
      </FormItemStyled> : <></>}

      {data?.old_pwd || !data?.id ? <FormItemStyled gap={DEFAULTGAP}>
        <TextPwdComponent
          props={{
            autoComplete: 'new-password',
            label: 'Confirme a nova senha',
            onChange: (e) => {
              setConfirmedPwd(e.target.value)
            },
            error: data?.pwd != confirmedPwd,
            helperText: data?.pwd != confirmedPwd ? 'As senhas não conferem' : null
          }}
        />
      </FormItemStyled> : <></>}
    </FormStyled>

    <UserAddInfoTabsComponent
      groupsProps={{
        data: data?.groups,
        onSelectItem: (u_g: IUser_Group, userGroup: IUserGroup) => {
          let groupsTmp = data?.groups?.filter(g => g.usergroup?.id == userGroup.id && g.uuid !== u_g.uuid)
          if (groupsTmp?.length) {
            enqueueSnackbar('Grupo já adicionado', { variant: 'error' })
            return
          }
          let users_groups = [...data?.groups || []]
          for (let oldU_g of users_groups) {
            if (oldU_g.uuid === u_g.uuid) {
              oldU_g.usergroup_id = userGroup.id
              oldU_g.usergroup = userGroup
              break
            }
          }
          setData({
            ...data,
            groups: users_groups
          } as IUser)
        },
        onAddItem: () => {
          const groups = [...data?.groups || []]
          
          if (groups?.filter(g => g.usergroup_id == 0).length)
            return

          groups.push({
            uuid: CommonUtils.getNewUuid(),
            id: 0,
            user_id: data?.id || 0,
            usergroup_id: 0
          })
          setData({
            ...data,
            groups,
          } as IUser)
        },
        onDeleteItem: (item: IUser_Group) => {
          setData({
            ...data,
            groups: data?.groups?.filter(g => g.uuid != item.uuid)
          } as IUser)
        }
      }}

      logsProps={props.id ? {
        userId: props.id,
        logs: data?.logs,
        onSearchClick: getLogs,
        onChangeParams: setWhere,
        onRefreshClick: getLogs
      } : undefined}
    />

    <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={save} />
  </>
}